export default __webpack_public_path__ + "static/media/img4.78646e96.jpg";